import { SELL_TRACTOR_SURVEY_FEATURE_VERSION } from '../../constants/tempData/tempData.contant';
import { IUserSellTractorTempData } from '../../interfaces/Element.interfaces';
import { userSellTractorSurveyStateType } from '../../store/userSellTractorSurveySlice';

export interface ICreateUserSellTractorTempDataParam {
  formData: userSellTractorSurveyStateType;
  isUserSubmit: boolean;
}

interface ICreateUserSellTractorTempDataReturn {
  newSellTractorTempData: string;
}

export const createUserSellTractorTempData = ({
  formData,
  isUserSubmit,
}: ICreateUserSellTractorTempDataParam): ICreateUserSellTractorTempDataReturn => {
  const sellTractorTempData: IUserSellTractorTempData = {
    version: SELL_TRACTOR_SURVEY_FEATURE_VERSION,
    createDate: new Date(),
    formData,
    isUserSubmit,
  };
  return { newSellTractorTempData: JSON.stringify(sellTractorTempData) };
};
